<div class="header">
  <div class="title">Panel Logic</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="panelLogicForm">
  <div class="row description flex flex-col">
    <mat-form-field class="treo-mat-textarea treo-mat-no-subscript w-full">
      <mat-label>Conditional Logic</mat-label>
      <textarea matInput treoAutogrow [formControlName]="'conditional_logic'" [spellcheck]="false"></textarea>
    </mat-form-field>
    <span *ngIf="error" class="text-red-500 mt-2"> {{ error }} </span>
  </div>

  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button tabindex="1" type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        tabindex="0"
        [disabled]="panelLogicForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!panelLogicForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="panelLogicForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
